import { LoadingOverlay } from '@mantine/core'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import { useRouter } from 'next/router'
import React, { createContext, ReactNode, useContext, useEffect } from 'react'

import { IInstitute } from '@/features/institute/types'

dayjs.extend(isBetween)
export interface IInstituteContextState {
  instituteInfo: IInstitute | null
}

interface IInstituteProviderProps {
  children: ReactNode
  instituteInfo: IInstitute | null
  isLoading: boolean
}

const InstituteContext = createContext<IInstituteContextState>({
  instituteInfo: null,
})

const InstituteProvider = ({ children, instituteInfo, isLoading }: IInstituteProviderProps) => {
  const router = useRouter()

  useEffect(() => {
    const curDate = dayjs()
    if (
      instituteInfo &&
      !curDate.isBetween(dayjs(instituteInfo?.startAt), dayjs(instituteInfo?.endAt))
    ) {
      return void router.push('/oauth')
    }
  }, [instituteInfo])

  if (isLoading)
    return (
      <LoadingOverlay
        visible={true}
        overlayProps={{ radius: 'sm', blur: 2, backgroundOpacity: 0 }}
        loaderProps={{ color: 'gray', size: 'xl' }}
      />
    )

  return (
    <InstituteContext.Provider value={{ instituteInfo: instituteInfo ?? null }}>
      {children}
    </InstituteContext.Provider>
  )
}

export default InstituteProvider
export const useInstitute = () => useContext(InstituteContext)
